<template>
  <v-dialog v-model="dialog" max-width="650px">
    <v-card>
      <v-card-title>
        <span class="headline">Ordenar Itens do Template</span>
      </v-card-title>

      <v-card-text>
        <div
          v-for="group in groupedOrderedItems"
          :key="group.className"
          class="mb-6"
        >
          <h4 class="mb-2">{{ group.className }}</h4>

          <v-list dense>
            <draggable
              v-model="group.items"
              tag="div"
              :animation="150"
              :disabled="loading"
              handle=".drag-handle"
              @start="isDragging = true"
              @end="onDragEnd"
              style="width: 100%"
            >
              <v-list-item
                v-for="(item, idx) in group.items"
                :key="item.relId"
                class="px-2"
              >
                <v-icon class="drag-handle mr-3" style="cursor: move">
                  mdi-drag-vertical
                </v-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ idx + 1 }}. {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </div>

        <div v-if="!groupedOrderedItems.length" class="text--secondary">
          Nenhum item encontrado para ordenar.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="saveOrder"
        >
          Salvar Ordem
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'InspectionRoutineOrdenation',
  components: { draggable },

  props: {
    value: Boolean,
    template: { type: Object, required: true },
    items: { type: Array, default: () => [] },
  },

  data() {
    return {
      dialog: this.value,
      groupedOrderedItems: [],
      loading: false,
      apiService: new ApiService(),
      isDragging: false,
    }
  },

  mounted() {
    this.buildGroupsFromProps()
  },

  watch: {
    value(val) {
      this.dialog = val
      if (val) this.buildGroupsFromProps()
    },

    dialog(val) {
      this.$emit('input', val)
      if (val) this.buildGroupsFromProps()
    },

    items: {
      handler() {
        this.buildGroupsFromProps()
      },
      immediate: true,
      deep: false,
    },
  },

  methods: {
    close() {
      this.dialog = false
    },

    buildGroupsFromProps() {
      const map = {}

      const flat = (this.items || [])
        .filter((ti) => ti && ti.item)
        .map((ti) => ({
          relId: ti.id,
          order: ti.order,
          name: ti.item.name,
          className: ti.item.inspectionRoutineChecklistItemClass
            ? ti.item.inspectionRoutineChecklistItemClass.name
            : 'Sem Classe',
        }))
        .sort((a, b) => (a.order ?? 999999) - (b.order ?? 999999))

      flat.forEach((item) => {
        const className = item.className
        if (!map[className]) map[className] = []
        map[className].push({ ...item })
      })

      const orderedClassNames = Object.keys(map).sort((a, b) => {
        if (a === 'Sem Classe') return 1
        if (b === 'Sem Classe') return -1
        return a.localeCompare(b)
      })

      this.groupedOrderedItems = orderedClassNames.map((className) => ({
        className,
        items: map[className],
      }))
    },

    buildPayload() {
      const ordered = this.groupedOrderedItems.flatMap((g) => g.items)

      return {
        templateId: this.template.id,
        itemOrders: ordered.map((item, idx) => ({
          id: item.relId,
          order: idx + 1,
        })),
      }
    },

    async onDragEnd() {
      this.isDragging = false
      await this.saveOrderToDatabase()
    },

    async saveOrderToDatabase() {
      this.loading = true
      try {
        const payload = this.buildPayload()
        await this.apiService.post(
          'inspectionRoutineChecklistTemplate/update-items-order',
          payload
        )
      } finally {
        this.loading = false
      }
    },

    async saveOrder() {
      this.loading = true
      try {
        const payload = this.buildPayload()
        await this.apiService.post(
          'inspectionRoutineChecklistTemplate/update-items-order',
          payload
        )

        const response = await this.apiService.get(
          `inspectionRoutineChecklistTemplate/${this.template.id}`
        )
        this.$emit('save', response.content.items || [])

        this.close()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.drag-handle {
  cursor: grab;
}
</style>
